import { Instagram, ArrowUpRight } from "lucide-react";
import { INSTAGRAM_URL, CTA_TEXT } from "@/constants/seo";

export const CtaButton = ({ variant = "primary", className = "", testid, label = CTA_TEXT }) => {
  const base =
    "group inline-flex items-center justify-center gap-3 rounded-none px-8 py-4 font-semibold uppercase tracking-[0.18em] text-sm transition-colors duration-300";
  const styles =
    variant === "primary"
      ? "btn-gold"
      : "border border-[#d4af37]/50 bg-transparent text-[#d4af37] hover:bg-[#d4af37]/10 hover:border-[#d4af37]";
  return (
    <a
      href={INSTAGRAM_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      className={`${base} ${styles} ${className}`}
    >
      <Instagram className="h-4 w-4" strokeWidth={2} />
      {label}
      <ArrowUpRight className="h-4 w-4 -translate-x-1 opacity-0 transition-all duration-300 group-hover:translate-x-0 group-hover:opacity-100" />
    </a>
  );
};
